module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/hypercard-logo-c6daaddb5dbd1704b66ff5cef71365ff.svg";